import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import MdmIcon from '~/components/atoms/Global/MdmIcon.vue';
var MdmLink = function MdmLink() {
  return import('~/components/atoms/MdmLink.vue');
};
export default {
  name: 'IconTextLink',
  components: {
    MdmIcon: MdmIcon,
    MdmLink: MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    },
    isPreventDefaultLink: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    to: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'light',
      validator: function validator(value) {
        return ['dark', 'light'].includes(value);
      }
    }
  },
  computed: {
    themeClass: function themeClass() {
      return this.theme === 'light' ? 'theme-light' : 'theme-dark';
    }
  }
};